import { useCallback, useEffect, useState } from "react";
import _ from "lodash";
import { getEStates } from "../../services/roleService";

const useEState = () => {
  const [data, setData] = useState([]);
  const [estateList, setEstateList] = useState([]);

  const fetchData = useCallback(async () => {
    const res = await getEStates();
    if (res.data.code === "0000") {
      const { objectValue } = res.data;
      setData(objectValue);

      const mapValue = objectValue.map((data) => {
        return {
          ...data,
          value: data.estateNameTh,
          id: _.get(data, "estateId"),
          key: _.get(data, "estateId")
        };
      });
      
      setEstateList(mapValue);
    }
  }, [setData, setEstateList]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  return [data, estateList];
};

export default useEState;
